import { PLAN } from '../../lib/api-routes'
import { HttpResponse, instance } from '../../lib/axiosInstance'
import { GetPlanParams } from '../../types/plan.interface'

export const getPlan = async (
  params: GetPlanParams
): Promise<HttpResponse | undefined> => {
  try {
    return await instance.get(PLAN, {
      params,
    })
  } catch (e) {}
  return undefined
}
